import React, {useEffect} from "react";
import "../styles/Team.css"; // CSS for styling
import gift from "../assets/gift1.jpeg";
import sewela from "../assets/sewela2.jpeg";
import koketso from "../assets/koketso.jpeg";
import ndamu from "../assets/ndamu.jpeg";
import olivia from "../assets/olivia.jpeg"
import { motion } from "framer-motion";



const TeamMember = ({ name, role, description, image }) => (
  <motion.div
    className="team-member"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    whileHover={{ scale: 1.05 }}
  >
    <div className="member-image">
      <img src={image} alt={name} />
    </div>
    <div className="member-info">
      <h3>{name}</h3>
      <h4>{role}</h4>
      <p>{description}</p>
    </div>
  </motion.div>
);


const Team = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);
  const teamMembers = [
    {
      name: "Gift Ntimani",
      role: "CEO & Founder",
      description:
         "Gift Ntimani is the visionary founder of GiftEng Aerial Solutions. With a passion for technology and community development, she leads the team in providing innovative drone solutions and empowering disadvantaged communities through education and mentorship. In addition to her leadership role, Gift is a skilled Remote Pilot within the company, actively engaging in flight operations and client projects. She also contributes as the Mathematics Mentor, guiding aspiring remote pilots in developing essential math skills for the aviation industry.",
      image: gift,
    },
    {
      name: "Pheladi Sekgobela",
      role: "Remote Pilot & English Mentor",
      description:
        "Sewala is a skilled remote pilot at GiftEng Aerial Solutions and an English mentor . She plays a key role in mentoring students and contributing to the company's educational outreach programs.",
      image: sewela,
    },
    {
      name: "Koketso Ntimani",
      role: "Operations Manager",
      description:
        "Koketso Ntimani is responsible for ensuring smooth operations at GiftEng Aerial Solutions. Her expertise in logistics and drone operations helps streamline the company’s day-to-day activities.",
      image: koketso,
    },
    {
      name: "Ndamulelo Mulaudzi",
      role: "Software Engineer",
      description:
        "Ndamulelo is a Software Engineer at GiftEng Aerial Solutions. With a focus on developing innovative software solutions, Ndamulelo helps drive the company's technological advancements.",
      image: ndamu,
    },
    {
      name: "Olivia Mhokore",
      role: "Social Media Manager",
      description:
        "Olivia is responsible for developing, implementing, and overseeing a company’s social media strategy to enhance brand visibility, engagement, and growth across various platforms.",
      image: olivia,
    },
  ];

  return (
    <div className="our-team-page">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Meet Our Team
      </motion.h1>
      <motion.div
        className="team-members"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 1 },
          visible: {
            opacity: 1,
            transition: {
              delayChildren: 0.3,
              staggerChildren: 0.2,
            },
          },
        }}
      >
        {teamMembers.map((member, index) => (
          <TeamMember
            key={index}
            name={member.name}
            role={member.role}
            description={member.description}
            image={member.image}
          />
        ))}
      </motion.div>
    </div>
  );
};

export default Team;
